var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4c07b348"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "statusCard shadowed" };
const _hoisted_2 = { class: "headerRow" };
const _hoisted_3 = { class: "name" };
const _hoisted_4 = { class: "status" };
const _hoisted_5 = {
    key: 0,
    style: { "text-align": "center" }
};
const _hoisted_6 = {
    key: 1,
    class: "detail"
};
const _hoisted_7 = { key: 0 };
const _hoisted_8 = { class: "infoBox" };
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("strong", null, "not indicated", -1));
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "mt-2" }, [
    /*#__PURE__*/ _createElementVNode("strong", null, "Please inform us if this is required.")
], -1));
const _hoisted_11 = { class: "buttons mt-4" };
const _hoisted_12 = { key: 1 };
const _hoisted_13 = { class: "infoBox" };
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("strong", null, "does NOT require", -1));
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "mt-2" }, [
    /*#__PURE__*/ _createElementVNode("strong", null, "Please inform us if this is incorrect.")
], -1));
const _hoisted_16 = { class: "buttons mt-4" };
const _hoisted_17 = { key: 2 };
const _hoisted_18 = { class: "infoBox" };
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("strong", null, "already has", -1));
const _hoisted_20 = { key: 0 };
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "mt-2" }, [
    /*#__PURE__*/ _createElementVNode("strong", null, "Please upload a digital copy / scan below, or inform us if this is incorrect.")
], -1));
const _hoisted_22 = { class: "buttons mt-4" };
const _hoisted_23 = { key: 1 };
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "mt-2" }, [
    /*#__PURE__*/ _createElementVNode("strong", null, "Please find the digital copy / scan available for download below.")
], -1));
const _hoisted_25 = [
    _hoisted_24
];
const _hoisted_26 = { key: 3 };
const _hoisted_27 = { class: "infoBox" };
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("strong", null, "needs to apply for", -1));
const _hoisted_29 = {
    key: 0,
    class: "mt-2"
};
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("strong", null, [
    /*#__PURE__*/ _createTextVNode(" Please have the citizen visit the "),
    /*#__PURE__*/ _createElementVNode("a", {
        class: "tag is-light is-rounded has-text-weight-bold ml-1",
        href: "https://my.minicityatl.com",
        target: "_blank"
    }, [
        /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-external-link-alt mr-2" }),
        /*#__PURE__*/ _createTextVNode(" my.minicityatl.com ")
    ]),
    /*#__PURE__*/ _createTextVNode(" portal to complete an application, or inform us if this is not required. ")
], -1));
const _hoisted_31 = [
    _hoisted_30
];
const _hoisted_32 = { key: 1 };
const _hoisted_33 = { class: "mt-2" };
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "mt-2" }, [
    /*#__PURE__*/ _createElementVNode("strong", null, "Please work directly with the citizen to apply, and record your progress here.")
], -1));
const _hoisted_35 = { class: "buttons mt-4" };
const _hoisted_36 = { key: 4 };
const _hoisted_37 = { class: "infoBox" };
const _hoisted_38 = { class: "mt-2" };
const _hoisted_39 = {
    key: 0,
    class: "buttons mt-4"
};
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("button", { class: "button is-info" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-external-link-alt mr-2" }),
    /*#__PURE__*/ _createTextVNode(" View Application Page ")
], -1));
const _hoisted_41 = { key: 5 };
const _hoisted_42 = { class: "infoBox" };
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("strong", null, "applied for", -1));
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "mt-2" }, [
    /*#__PURE__*/ _createElementVNode("strong", null, "Please let us know when the application status changes.")
], -1));
const _hoisted_45 = { class: "buttons mt-4" };
const _hoisted_46 = { key: 6 };
const _hoisted_47 = { class: "infoBox" };
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("strong", null, "successfully obtained", -1));
const _hoisted_49 = { key: 0 };
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "mt-2" }, [
    /*#__PURE__*/ _createElementVNode("strong", null, "When / if a digital copy is available, it will be attached below.")
], -1));
const _hoisted_51 = [
    _hoisted_50
];
const _hoisted_52 = { key: 1 };
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "mt-2" }, [
    /*#__PURE__*/ _createElementVNode("strong", null, "Please find the digital copy / scan available for download below.")
], -1));
const _hoisted_54 = [
    _hoisted_53
];
const _hoisted_55 = {
    key: 2,
    class: "buttons mt-4"
};
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("button", { class: "button is-info" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-external-link-alt mr-2" }),
    /*#__PURE__*/ _createTextVNode(" View Application Page ")
], -1));
const _hoisted_57 = { key: 7 };
const _hoisted_58 = { class: "infoBox" };
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("strong", null, "successfully obtained", -1));
const _hoisted_60 = { key: 0 };
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "mt-2" }, [
    /*#__PURE__*/ _createElementVNode("strong", null, "Please upload a digital copy / scan below, or inform us if this is incorrect.")
], -1));
const _hoisted_62 = { class: "buttons mt-4" };
const _hoisted_63 = { key: 1 };
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "mt-2" }, [
    /*#__PURE__*/ _createElementVNode("strong", null, "Please find the digital copy / scan available for download below.")
], -1));
const _hoisted_65 = [
    _hoisted_64
];
const _hoisted_66 = {
    key: 8,
    class: "mt-4 columns is-mobile"
};
const _hoisted_67 = { class: "column" };
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "label" }, "Digital Copy / Scan (.PNG, .JPG, or .PDF)", -1));
import { computed, ref } from 'vue';
import { doApiAction } from '@/core/api';
import { formatDateTime } from "@/core/utils";
import { requestStatusLabels } from "@/features/applications/model";
import DocumentUploadWidget from '@/components/DocumentUploadWidget.vue';
import DocumentUploadButton from '@/components/DocumentUploadButton.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'KeyDocumentCard',
    props: {
        keyDocumentType: {},
        keyDocument: {},
        setStatus: { type: Function },
        uploadAttachment: { type: Function },
        deleteAttachment: { type: Function },
        getAttachmentViewLink: { type: Function }
    },
    setup(__props) {
        const props = __props;
        const opened = ref(false);
        const loading = ref(false);
        const typeLabels = {
            "BIRTH_RECORD": "Birth Record",
            "SOCIAL_SECURITY": "Social Security Card",
            "STATE_ID": "State ID",
            "VETERAN_ID": "Veteran ID",
            "GEORGIA_DFCS_BENEFITS": "Georgia DFCS Benefits",
        };
        const statusLabels = {
            "UNKNOWN": "Unknown",
            "NOT_REQUIRED": "Not Required",
            "ALREADY_HAS": "Already Has",
            "REQUIRED": "Required",
            "APPLIED": "Applied",
            "OBTAINED": "Obtained",
        };
        const inProgressAction = ref(null);
        const doSetStatus = (status) => {
            loading.value = true;
            props.setStatus(status).finally(() => loading.value = false);
        };
        const doUploadAttachment = (uploadInfo) => {
            doApiAction(inProgressAction, "uploadAttachment", "Attachment uploaded", "Failed to upload attachment", () => __awaiter(this, void 0, void 0, function* () {
                yield props.uploadAttachment(uploadInfo.file).finally(() => uploadInfo.onDone());
            }));
        };
        const doDeleteAttachment = (doc) => {
            doApiAction(inProgressAction, "deleteAttachment", "Attachment deleted", "Failed to delete attachment", () => __awaiter(this, void 0, void 0, function* () {
                yield props.deleteAttachment(doc.id);
            }));
        };
        const doDownloadAttachment = (doc) => {
            doApiAction(inProgressAction, "downloadAttachment", null, "Failed to download attachment", () => __awaiter(this, void 0, void 0, function* () {
                yield props.getAttachmentViewLink(doc.id)
                    .then((attachmentViewLink) => window.open(attachmentViewLink));
            }));
        };
        const applicationLink = computed(() => {
            if (!props.keyDocument.application)
                return null;
            switch (props.keyDocumentType) {
                case "BIRTH_RECORD": return `/birthRecords/${props.keyDocument.application.id}`;
                case "GEORGIA_DFCS_BENEFITS": return `/georgiaBenefits/${props.keyDocument.application.id}`;
                case "SOCIAL_SECURITY": return `/socialSecurity/${props.keyDocument.application.id}`;
                default: return null;
            }
        });
        return (_ctx, _cache) => {
            const _component_LoadingSpinner = _resolveComponent("LoadingSpinner");
            const _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, _toDisplayString(typeLabels[_ctx.keyDocumentType]), 1),
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", {
                            style: { "width": "fit-content" },
                            class: _normalizeClass(["statusName my-1", _ctx.keyDocument.status])
                        }, _toDisplayString(statusLabels[_ctx.keyDocument.status]), 3)
                    ]),
                    (opened.value)
                        ? (_openBlock(), _createElementBlock("i", {
                            key: 0,
                            onClick: _cache[0] || (_cache[0] = ($event) => (opened.value = false)),
                            class: "toggleButton fas fa-chevron-up"
                        }))
                        : (_openBlock(), _createElementBlock("i", {
                            key: 1,
                            onClick: _cache[1] || (_cache[1] = ($event) => (opened.value = true)),
                            class: "toggleButton fas fa-chevron-down"
                        }))
                ]),
                (loading.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createVNode(_component_LoadingSpinner)
                    ]))
                    : (opened.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            (_ctx.keyDocument.status == 'UNKNOWN')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                    _createElementVNode("div", _hoisted_8, [
                                        _createElementVNode("p", null, [
                                            _createTextVNode("You have "),
                                            _hoisted_9,
                                            _createTextVNode(" whether this citizen requires their " + _toDisplayString(typeLabels[_ctx.keyDocumentType]) + ".", 1)
                                        ]),
                                        _hoisted_10,
                                        _createElementVNode("div", _hoisted_11, [
                                            _createElementVNode("button", {
                                                class: "button is-info",
                                                onClick: _cache[2] || (_cache[2] = ($event) => (doSetStatus('REQUIRED')))
                                            }, "Apply for the citizen's " + _toDisplayString(typeLabels[_ctx.keyDocumentType]), 1),
                                            _createElementVNode("button", {
                                                class: "button is-info",
                                                onClick: _cache[3] || (_cache[3] = ($event) => (doSetStatus('NOT_REQUIRED')))
                                            }, "The citizen DOES NOT require their " + _toDisplayString(typeLabels[_ctx.keyDocumentType]), 1),
                                            _createElementVNode("button", {
                                                class: "button is-info",
                                                onClick: _cache[4] || (_cache[4] = ($event) => (doSetStatus('ALREADY_HAS')))
                                            }, "The citizen already has their " + _toDisplayString(typeLabels[_ctx.keyDocumentType]), 1)
                                        ])
                                    ])
                                ]))
                                : (_ctx.keyDocument.status == 'NOT_REQUIRED')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                        _createElementVNode("div", _hoisted_13, [
                                            _createElementVNode("p", null, [
                                                _createTextVNode("You have indicated that this citizen "),
                                                _hoisted_14,
                                                _createTextVNode(" their " + _toDisplayString(typeLabels[_ctx.keyDocumentType]) + ".", 1)
                                            ]),
                                            _hoisted_15,
                                            _createElementVNode("div", _hoisted_16, [
                                                _createElementVNode("button", {
                                                    class: "button is-info",
                                                    onClick: _cache[5] || (_cache[5] = ($event) => (doSetStatus('REQUIRED')))
                                                }, "Apply for the citizen's " + _toDisplayString(typeLabels[_ctx.keyDocumentType]), 1),
                                                _createElementVNode("button", {
                                                    class: "button is-info",
                                                    onClick: _cache[6] || (_cache[6] = ($event) => (doSetStatus('ALREADY_HAS')))
                                                }, "The citizen already has their " + _toDisplayString(typeLabels[_ctx.keyDocumentType]), 1)
                                            ])
                                        ])
                                    ]))
                                    : (_ctx.keyDocument.status == 'ALREADY_HAS')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                            _createElementVNode("div", _hoisted_18, [
                                                _createElementVNode("p", null, [
                                                    _createTextVNode("You have indicated that this citizen "),
                                                    _hoisted_19,
                                                    _createTextVNode(" their " + _toDisplayString(typeLabels[_ctx.keyDocumentType]) + ".", 1)
                                                ]),
                                                (_ctx.keyDocument.attachments.length == 0)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                                        _hoisted_21,
                                                        _createElementVNode("div", _hoisted_22, [
                                                            _createVNode(DocumentUploadButton, {
                                                                label: `Upload ${typeLabels[_ctx.keyDocumentType]}`,
                                                                document: null,
                                                                onUpload: _cache[7] || (_cache[7] = ($event) => (doUploadAttachment($event)))
                                                            }, null, 8, ["label"]),
                                                            _createElementVNode("button", {
                                                                class: "button is-info",
                                                                onClick: _cache[8] || (_cache[8] = ($event) => (doSetStatus('UNKNOWN')))
                                                            }, "The citizen DOES NOT have their " + _toDisplayString(typeLabels[_ctx.keyDocumentType]), 1)
                                                        ])
                                                    ]))
                                                    : (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_25))
                                            ])
                                        ]))
                                        : (_ctx.keyDocument.status == 'REQUIRED')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                                _createElementVNode("div", _hoisted_27, [
                                                    _createElementVNode("p", null, [
                                                        _createTextVNode("You have indicated that this citizen "),
                                                        _hoisted_28,
                                                        _createTextVNode(" their " + _toDisplayString(typeLabels[_ctx.keyDocumentType]) + ".", 1)
                                                    ]),
                                                    (['BIRTH_RECORD', 'SOCIAL_SECURITY', 'GEORGIA_DFCS_BENEFITS'].includes(_ctx.keyDocumentType))
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_29, _hoisted_31))
                                                        : (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                                            _createElementVNode("p", _hoisted_33, "We are not currently able to automate the application process for " + _toDisplayString(typeLabels[_ctx.keyDocumentType]) + ".", 1),
                                                            _hoisted_34
                                                        ])),
                                                    _createElementVNode("div", _hoisted_35, [
                                                        _createElementVNode("button", {
                                                            class: "button is-info",
                                                            onClick: _cache[9] || (_cache[9] = ($event) => (doSetStatus('NOT_REQUIRED')))
                                                        }, "The citizen DOES NOT require their " + _toDisplayString(typeLabels[_ctx.keyDocumentType]), 1),
                                                        _createElementVNode("button", {
                                                            class: "button is-info",
                                                            onClick: _cache[10] || (_cache[10] = ($event) => (doSetStatus('ALREADY_HAS')))
                                                        }, "The citizen already has their " + _toDisplayString(typeLabels[_ctx.keyDocumentType]), 1),
                                                        (!['BIRTH_RECORD', 'SOCIAL_SECURITY', 'GEORGIA_DFCS_BENEFITS'].includes(_ctx.keyDocumentType))
                                                            ? (_openBlock(), _createElementBlock("button", {
                                                                key: 0,
                                                                class: "button is-info",
                                                                onClick: _cache[11] || (_cache[11] = ($event) => (doSetStatus('APPLIED')))
                                                            }, "We Have Applied For Their " + _toDisplayString(typeLabels[_ctx.keyDocumentType]), 1))
                                                            : _createCommentVNode("", true)
                                                    ])
                                                ])
                                            ]))
                                            : (_ctx.keyDocument.status == 'APPLIED' && ['BIRTH_RECORD', 'SOCIAL_SECURITY', 'GEORGIA_DFCS_BENEFITS'].includes(_ctx.keyDocumentType))
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                                    _createElementVNode("div", _hoisted_37, [
                                                        _createElementVNode("p", null, [
                                                            _createTextVNode("An application was started "),
                                                            _createElementVNode("strong", null, _toDisplayString(_unref(formatDateTime)(_ctx.keyDocument.application.createdAt)), 1),
                                                            _createTextVNode(".")
                                                        ]),
                                                        _createElementVNode("p", _hoisted_38, [
                                                            _createTextVNode("The current status of this application is: "),
                                                            _createElementVNode("strong", null, _toDisplayString(_unref(requestStatusLabels)[_ctx.keyDocument.application.status]), 1),
                                                            _createTextVNode(".")
                                                        ]),
                                                        (applicationLink.value)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                                                _createVNode(_component_router_link, {
                                                                    to: applicationLink.value,
                                                                    target: "_blank"
                                                                }, {
                                                                    default: _withCtx(() => [
                                                                        _hoisted_40
                                                                    ]),
                                                                    _: 1
                                                                }, 8, ["to"])
                                                            ]))
                                                            : _createCommentVNode("", true)
                                                    ])
                                                ]))
                                                : (_ctx.keyDocument.status == 'APPLIED')
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                                        _createElementVNode("div", _hoisted_42, [
                                                            _createElementVNode("p", null, [
                                                                _createTextVNode("You have indicated that you have "),
                                                                _hoisted_43,
                                                                _createTextVNode(" the citizen's " + _toDisplayString(typeLabels[_ctx.keyDocumentType]) + ".", 1)
                                                            ]),
                                                            _hoisted_44,
                                                            _createElementVNode("div", _hoisted_45, [
                                                                _createElementVNode("button", {
                                                                    class: "button is-info",
                                                                    onClick: _cache[12] || (_cache[12] = ($event) => (doSetStatus('NOT_REQUIRED')))
                                                                }, "The citizen DOES NOT require their " + _toDisplayString(typeLabels[_ctx.keyDocumentType]), 1),
                                                                _createElementVNode("button", {
                                                                    class: "button is-info",
                                                                    onClick: _cache[13] || (_cache[13] = ($event) => (doSetStatus('OBTAINED')))
                                                                }, "We have obtained the citizen's " + _toDisplayString(typeLabels[_ctx.keyDocumentType]), 1)
                                                            ])
                                                        ])
                                                    ]))
                                                    : (_ctx.keyDocument.status == 'OBTAINED' && ['BIRTH_RECORD', 'SOCIAL_SECURITY', 'GEORGIA_DFCS_BENEFITS'].includes(_ctx.keyDocumentType))
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                                            _createElementVNode("div", _hoisted_47, [
                                                                _createElementVNode("p", null, [
                                                                    _createTextVNode("We have "),
                                                                    _hoisted_48,
                                                                    _createTextVNode(" the citizen's " + _toDisplayString(typeLabels[_ctx.keyDocumentType]) + ".", 1)
                                                                ]),
                                                                (_ctx.keyDocument.attachments.length == 0)
                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_49, _hoisted_51))
                                                                    : (_openBlock(), _createElementBlock("div", _hoisted_52, _hoisted_54)),
                                                                (applicationLink.value)
                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                                                        _createVNode(_component_router_link, {
                                                                            to: applicationLink.value,
                                                                            target: "_blank"
                                                                        }, {
                                                                            default: _withCtx(() => [
                                                                                _hoisted_56
                                                                            ]),
                                                                            _: 1
                                                                        }, 8, ["to"])
                                                                    ]))
                                                                    : _createCommentVNode("", true)
                                                            ])
                                                        ]))
                                                        : (_ctx.keyDocument.status == 'OBTAINED')
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                                                _createElementVNode("div", _hoisted_58, [
                                                                    _createElementVNode("p", null, [
                                                                        _createTextVNode("You have indicated that this citizen has "),
                                                                        _hoisted_59,
                                                                        _createTextVNode(" their " + _toDisplayString(typeLabels[_ctx.keyDocumentType]) + ".", 1)
                                                                    ]),
                                                                    (_ctx.keyDocument.attachments.length == 0)
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                                                                            _hoisted_61,
                                                                            _createElementVNode("div", _hoisted_62, [
                                                                                _createVNode(DocumentUploadButton, {
                                                                                    label: `Upload ${typeLabels[_ctx.keyDocumentType]}`,
                                                                                    document: null,
                                                                                    onUpload: _cache[14] || (_cache[14] = ($event) => (doUploadAttachment($event)))
                                                                                }, null, 8, ["label"]),
                                                                                _createElementVNode("button", {
                                                                                    class: "button is-info",
                                                                                    onClick: _cache[15] || (_cache[15] = ($event) => (doSetStatus('APPLIED')))
                                                                                }, "We are still applying for the citizen's " + _toDisplayString(typeLabels[_ctx.keyDocumentType]), 1)
                                                                            ])
                                                                        ]))
                                                                        : (_openBlock(), _createElementBlock("div", _hoisted_63, _hoisted_65))
                                                                ])
                                                            ]))
                                                            : _createCommentVNode("", true),
                            (_ctx.keyDocument.attachments.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                                    _createElementVNode("div", _hoisted_67, [
                                        _hoisted_68,
                                        _createVNode(DocumentUploadWidget, {
                                            documents: _ctx.keyDocument.attachments,
                                            onUpload: _cache[16] || (_cache[16] = ($event) => (doUploadAttachment($event))),
                                            onDelete: _cache[17] || (_cache[17] = ($event) => (doDeleteAttachment($event))),
                                            onView: _cache[18] || (_cache[18] = ($event) => (doDownloadAttachment($event)))
                                        }, null, 8, ["documents"])
                                    ])
                                ]))
                                : _createCommentVNode("", true)
                        ]))
                        : _createCommentVNode("", true)
            ]));
        };
    }
});
